import { render, staticRenderFns } from "./RoteirizacaoCollapsibleCard.vue?vue&type=template&id=b708d1f8&scoped=true&"
import script from "./RoteirizacaoCollapsibleCard.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoCollapsibleCard.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoCollapsibleCard.vue?vue&type=style&index=0&id=b708d1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b708d1f8",
  null
  
)

export default component.exports